import React from 'react';
import { TemplateMap } from 'components/shared/TemplateMap';

interface TemplateMapProps {
  templateId?: string;
}

const TransportTemplateMap: React.FC<TemplateMapProps> = ({ templateId }) => {
  return <TemplateMap templateId={templateId} variant="transport" />;
};

export default TransportTemplateMap;
